<template>
  <v-container>
    <v-layout row wrap>
      <v-flex xs12>
        <app-select label="Application" v-model="app.Id"></app-select>
      </v-flex>
      <v-flex xs12 v-if="app && app.CurrentStatus">
        <v-status
          label="Status"
          v-model="app.CurrentStatus.StatusID"
        ></v-status>
      </v-flex>
    </v-layout>

    <!-- Application is Awarded -->
    <v-layout
      row
      wrap
      v-if="app && app.CurrentStatus && app.CurrentStatus.StatusID == 7"
    >
      <v-flex xs12 sm6 pr-4>
        <date-picker
          label="Award Start Date"
          v-model="app.DateReward"
          :rules="[rules.date(app.DateReward, app.RewardEndDate)]"
        ></date-picker>
      </v-flex>
      <v-flex xs12 sm6 pr-4>
        <date-picker
          label="Award End Date"
          v-model="app.RewardEndDate"
          :rules="[rules.date(app.DateReward, app.RewardEndDate)]"
        ></date-picker>
      </v-flex>
      <v-flex xs12 sm6 pr-4>
        <v-text-field
          label="NPI Number"
          v-model="app.NPINumber"
          :rules="[rules.npinumber]"
        ></v-text-field>
      </v-flex>
      <v-flex xs12 sm6 pr-4>
        <v-text-field
          prepend-icon="attach_money"
          label="Federal Funds"
          v-model="app.FederalFunds"
          :rules="[rules.money]"
        ></v-text-field>
      </v-flex>
      <v-flex xs12 sm6 pr-4>
        <v-text-field
          prepend-icon="attach_money"
          label="General Funds"
          v-model="app.Generalfunds"
          :rules="[rules.money]"
        ></v-text-field>
      </v-flex>
      <v-flex xs12 sm6 pr-4>
        <v-text-field
          readonly
          label="Total Award Amount"
          prepend-icon="attach_money"
          :value="total"
        ></v-text-field>
      </v-flex>
    </v-layout>

    <!-- Application is in Default -->
    <v-layout
      row
      wrap
      v-if="app && app.CurrentStatus && app.CurrentStatus.StatusID == 12"
    >
      <v-flex xs12>
        <date-picker
          label="Date Defaulted"
          v-model="app.DefaultDate"
        ></date-picker>
      </v-flex>
      <v-flex xs12>
        <v-text-field
          label="Amount Owed By Healthcare Provider"
          prepend-icon="attach_money"
          v-model="app.DefaultAmountDue"
          :rules="[rules.money]"
        ></v-text-field>
      </v-flex>
      <span>Payments</span>
      <v-flex xs12>
        <v-layout row wrap v-for="(pay, idx) in app.DefaultPayments" :key="idx">
          <v-flex xs11>
            <v-layout row wrap>
              <v-flex xs12 md6 pr-4>
                <v-text-field
                  label="Amount"
                  prepend-icon="attach_money"
                  v-model="pay.AmountPaid"
                  :rules="[rules.money]"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md6 pr-4>
                <date-picker label="Date Paid" v-model="pay.Date"></date-picker>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs1>
            <v-btn icon color="secondary" @click="removePayment(idx)"
              ><v-icon>clear</v-icon></v-btn
            >
          </v-flex>
        </v-layout>
      </v-flex>
      <v-btn
        color="primary"
        @click="app.DefaultPayments.push({ ApplicationID: app.Id })"
        >add payment</v-btn
      >
    </v-layout>

    <!-- Withdrawn Applications -->
    <v-layout
      row
      wrap
      v-if="app && app.CurrentStatus && app.CurrentStatus.StatusID == 14"
    >
      <v-flex xs12>
        <date-picker
          label="Date Withdrawn"
          v-model="app.WithdrawnDate"
        ></date-picker>
      </v-flex>
    </v-layout>

    <!-- General Notes -->
    <v-layout row wrap>
      <v-flex xs12>
        <v-textarea label="Notes" v-model="app.Notes"></v-textarea>
      </v-flex>
    </v-layout>

    <v-layout justify-end>
      <v-flex xs12 v-if="isLoading || isSaving">
        <v-progress-linear
          indeterminate
          color="secondary"
          v-if="isLoading"
        ></v-progress-linear>
        <v-progress-linear
          indeterminate
          color="secondary"
          v-if="isSaving"
        ></v-progress-linear>
      </v-flex>
      <v-btn color="primary" @click="saveChanges">SAVE CHANGES</v-btn>
    </v-layout>
  </v-container>
</template>

<script>
import LuStatusVue from '../LuStatus.vue'
import DatePickerVue from '../DatePicker.vue'
import AppSelectVue from './AppSelect.vue'
import { mapActions } from 'vuex'
const moduleNameSpace = 'applications'
export default {
  props: {
    id: Number,
  },
  data() {
    return {
      app: {},
      rules: {
        date: (val, val2) => {
          return (
            val < val2 || 'Award Start Date must come before Award End Date'
          )
        },
        npinumber: (val) => {
          let pattern = /^\d+$/
          return pattern.test(value) || 'Value must be numeric'
        },
        money: (val) => {
          //debugger
          let pattern = /^(\d+|\d{1,3}(,\d{3})*)(\.\d+)?$/
          //  /^[+-]?[0-9]{1,3}(?:,?[0-9]{3})*\.[0-9]{2}$/
          return (
            pattern.test(val) ||
            'Please enter a monetary value formatted ####.## or #####.##'
          )
        },
      },
      isLoading: false,
      isSaving: false,
    }
  },
  computed: {
    total() {
      if (this.app.FederalFunds && this.app.Generalfunds) {
        let sum =
          parseFloat(this.app.FederalFunds.replace(',', '')) +
          parseFloat(this.app.Generalfunds.replace(',', ''))
        return sum
          .toLocaleString('en-US', { style: 'currency', currency: 'USD' })
          .replace('$', '')
      }
      return ''
    },
  },
  components: {
    'v-status': LuStatusVue,
    'date-picker': DatePickerVue,
    'app-select': AppSelectVue,
  },
  methods: {
    ...mapActions(moduleNameSpace, ['getApplicationByID']),
    _changeStatus() {
      var status = {
        ApplicationID: this.item.Id,
        StatusID: this.item.CurrentStatus.StatusID,
      }
    },
    removePayment(idx) {
      this.app.DefaultPayments.splice(idx, 1)
    },
    saveChanges() {
      this.isSaving = true
      axios
        .post('Applications/Action', this.app)
        .then((response) => {
          this.app = response.data
          if (this.app.FederalFunds && this.app.Generalfunds) {
            this.app.FederalFunds = this.app.FederalFunds.toLocaleString(
              'en-US',
              { style: 'currency', currency: 'USD' }
            ).replace('$', '')
            this.app.Generalfunds = this.app.Generalfunds.toLocaleString(
              'en-US',
              { style: 'currency', currency: 'USD' }
            ).replace('$', '')
          }
          let self = this
          this.$emit('refresh')
          setTimeout(() => {
            self.isSaving = false
          }, 500)
        })
        .catch((error) => {
          console.log(error)
          let self = this
          setTimeout(() => {
            self.isSaving = false
          }, 500)
        })
    },
  },
  watch: {
    id(val) {
      if (val > 0) {
        this.isLoading = true
        this.getApplicationByID(val)
          .then((response) => {
            this.app = response.data
            if (this.app.FederalFunds && this.app.Generalfunds) {
              this.app.FederalFunds = this.app.FederalFunds.toLocaleString(
                'en-US',
                { style: 'currency', currency: 'USD' }
              ).replace('$', '')
              this.app.Generalfunds = this.app.Generalfunds.toLocaleString(
                'en-US',
                { style: 'currency', currency: 'USD' }
              ).replace('$', '')
            }
            let self = this
            setTimeout(() => {
              self.isLoading = false
            }, 500)
          })
          .catch((err) => {
            console.log(err)
            let self = this
            setTimeout(() => {
              self.isLoading = false
            }, 500)
          })
      }
    },
    'app.Id': {
      handler(val) {
        this.isLoading = true
        this.getApplicationByID(val)
          .then((response) => {
            this.app = response.data
            if (this.app.FederalFunds && this.app.Generalfunds) {
              this.app.FederalFunds = this.app.FederalFunds.toLocaleString(
                'en-US',
                { style: 'currency', currency: 'USD' }
              ).replace('$', '')
              this.app.Generalfunds = this.app.Generalfunds.toLocaleString(
                'en-US',
                { style: 'currency', currency: 'USD' }
              ).replace('$', '')
            }
            let self = this
            setTimeout(() => {
              self.isLoading = false
            }, 500)
          })
          .catch((err) => {
            console.log(err)
            let self = this
            setTimeout(() => {
              self.isLoading = false
            }, 500)
          })
      },
    },
  },
}
</script>

<style></style>
